import { render, staticRenderFns } from "./manageFolder.vue?vue&type=template&id=03fb192f"
import script from "./manageFolder.vue?vue&type=script&lang=js"
export * from "./manageFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports